import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {
  faFile as faFileSolid,
  faFileMedicalAlt as faFileMedicalAltSolid,
} from '@fortawesome/fontawesome-pro-solid';
import {deduplicateArray} from 'libs/salmon-utils';

/**
 * Creates a document link with an appropriate icon based on the document type.
 *
 * @param {string} title - The title of the document to display
 * @param {string} resourceUrl - The URL of the document
 * @param {function} handleDocumentClick - Click handler for the document link
 * @returns {JSX.Element} A link element with an icon and title
 */
export const salmonDocumentLink = (title, resourceUrl, handleDocumentClick) => {
  switch (title) {
    case 'PA Form':
    case 'PA Criteria':
      return (
        <a onClick={handleDocumentClick} href={resourceUrl}>
          <FontAwesomeIcon icon={faFileMedicalAltSolid} />{title}
        </a>
      );
    case 'Coverage Document':
    default:
      return (
        <a onClick={handleDocumentClick} href={resourceUrl}>
          <FontAwesomeIcon icon={faFileSolid} />{title}
        </a>
      );
  }
};

/**
 * Formatter function for salmon documents in the coverage table
 *
 * @param {*} value - The cell value (unused)
 * @param {Object} options - The options object containing rowData
 * @param {Object} options.rowData - The row data containing salmonDocuments
 * @returns {JSX.Element} A div containing document links with line breaks
 */
export const formatterSalmonDocuments = (value, {rowData}, handleDocumentClick = null) => {
  // Remove duplicates if both title and resourceUrl are the same
  const uniqueDocuments = deduplicateArray(
    rowData.salmonDocuments,
    (doc) => `${doc.title}-${doc.resourceurl}`
  );

  return (
    <div>{uniqueDocuments.map((el) => (
      <React.Fragment key={`${el.title}-${el.resourceurl}`}>
        {salmonDocumentLink(el.title, el.resourceurl, handleDocumentClick)}
        <br/>
      </React.Fragment>
    ))}</div>
  );
};
